const config = {
  apiKey: "AIzaSyDgQvLVzL-IpUyZYrgwcQoCOGQwhaOEAKo",
  authDomain: "zglaudomat.firebaseapp.com",
  databaseURL: "https://zglaudomat.firebaseio.com",
  projectId: "zglaudomat",
  storageBucket: "zglaudomat.appspot.com",
  messagingSenderId: "598728744755",

  clientId:
    "598728744755-ofmgi8gq7mvvfkg4njh682knd239r0d6.apps.googleusercontent.com",
  scopes: [
    "email",
    "profile",
    "https://www.googleapis.com/auth/drive.metadata.readonly",
    "https://www.googleapis.com/auth/spreadsheets"
  ],
  discoveryDocs: [
    "https://sheets.googleapis.com/$discovery/rest?version=v4",
    "https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"
  ]
};

export default config;
